import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { v4 as uuidv4 } from 'uuid';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { EditorsPortal } from '../../editors/EditorsPortal';

const JRCThemeProvider = commonComponentsRegistry.getLazyComponent('ThemeProvider');

const createPortalElement = (parent: HTMLElement): HTMLDivElement => {
    let portal = document.getElementById('react-portals') as HTMLDivElement;

    if (!portal) {
        portal = document.createElement('div');
        portal.id = uuidv4();
        parent.appendChild(portal);
    }

    return portal;
};
export const EditorsPanel = () => {
    const portalDiv = document.getElementById('react-portals');
    const portal = useMemo(() => portalDiv && createPortalElement(portalDiv), [portalDiv]);

    if (!portal) {
        return null;
    }
    return createPortal(
        <JRCThemeProvider>
            <EditorsPortal />
        </JRCThemeProvider>,
        portal,
    );
};
